module.exports = __webpack_public_path__ + "b37562e4bce92deef3b80cb619478cd1.png";